import { useCallback } from 'react'
import { useHistory, useRouteMatch } from 'react-router'

import type { ITabItemProps } from './TabMenu'

export type ITabItem<V = string> = ITabItemProps<V> & { route?: string; path: string }

interface IUseRouterTabs<T extends ITabItem<V>[], V> {
  tabList: T
  isExact?: boolean
}

export const useRouterTabs = <V extends string, T extends ITabItem<V>[]>({
  tabList,
  isExact,
}: IUseRouterTabs<T, V>) => {
  const history = useHistory()
  const tabsPaths = tabList.map(({ path, route }) => route || path)
  const match = useRouteMatch({ path: tabsPaths, exact: isExact })

  const activeKey =
    tabList.find(({ path, route }) => (route || path) === match?.path)?.value || tabList[0].value

  const onChange = useCallback(
    (tab: V) => {
      const pathByTab = tabList.find(({ value }) => value === tab)?.path
      if (pathByTab) {
        history.replace(pathByTab)
      }
    },
    [history, tabList],
  )

  return { activeKey, onChange, tabList }
}
